/* eslint-disable import/prefer-default-export */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import {
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  Loading,
  FormGroup,
  ComposedModal,
  DatePickerSkeleton,
  TextArea,
  Button,
  Pagination,
  DataTable,
  DataTableSkeleton,
  Table,
  TableHeader,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  TextInput,
  FormLabel,
} from 'carbon-components-react';
import moment from 'moment';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import View16 from '@carbon/icons-react/lib/view--filled/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import SimpleReactValidator from 'simple-react-validator';
import { Link } from 'react-router-dom';
import {
  RenderDataTableCell,
  NoRecordsPlaceholder,
} from '../../../helpers/jsonschemaform/DataTableExtention';
import { FindGHRSEmployer } from '../../common/FindGHRSEmployer';
import PageBreadCrumb from '../../../helpers/PageBreadCrumb';
import { CanExecuteAction, IsInRole, IsEditable } from '../../../helpers/authorization/Policies';
import { showNotification } from '../../../helpers/notification/BaseNotification';
import {
  DateFormat,
  entitiesLabels,
  getError,
  apioperation,
  getSuccess,
} from '../../../helpers/Constants';
import DateTimePicker from '../../../helpers/DateTimePicker';
import { me, api, dynamic, inspection } from '../../../helpers/api/api';
import { AppContext } from '../../../helpers/context/AppContext';
import InspectionRepository from '../../../helpers/api/InspectionRepository';
import { Online, Offline } from '../../common/OnLineOffLine';
import FindSaipemCompilers from '../../common/FindSaipemCompilers';

export class InspectionCarList extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      isOpenModalGHRS: false,
      inspectionKey: this.props.match.params.id,
      inspectionCode: null,
      inspectionCarModel: null,
      inspectionModel: {},
      carList: [],
      // modale update
      mode: 0,
      isOpenModalCar: false,
      isLoadingElement: false,
      isLoadingDate: false,

      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
    };
    this.baseUrl = `/inspection/${this.state.inspectionKey}`;

    this.handleChangeGHRSModal = this.handleChangeGHRSModal.bind(this);
    this.setEmployer = this.setEmployer.bind(this);
    this.getIsEditable = this.getIsEditable.bind(this);
    this.getCanEditResource = this.getCanEditResource.bind(this);
    this.onDetailsOfInefficiencyChange = this.onDetailsOfInefficiencyChange.bind(this);
  }

  baseUrl;

  componentDidMount() {
    this.getCarList(this.state.inspectionKey);
  }

  handleCarDeleteCancel = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  getCarList(id) {
    this.setState({
      isLoadCar: true,
    });
    let data = {
      params: {
        page: this.state.currentPage,
        pageSize: this.state.pageSize,
      },
     };
    api
      .getWithParam(`inspection/${id}/car`, data)
      .then((response) => {
        if (response.status == 200) {
          let data = response.data;
        if (data) {
          this.setState({
            carList: response.data.inspectionCAR.itemList,
            inspectionModel: response.data.inspection,
            inspectionCode: response.data.inspectionCode,
            page: data.inspectionCAR.currentPage,
            pageSize:  data.inspectionCAR.pageSize,
            pageCount: data.inspectionCAR.pageCount,
            rowCount:  data.inspectionCAR.rowCount,
          });
        }
          
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.CAR, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadCar: false,
          isLoadingElement: false,
        });
      });
  }
  handleChangePaging = async (page) => {
    await new Promise((resolve) => {
      this.setState({ currentPage: page.page, pageSize: page.pageSize, loading: true  , isBack:false}, resolve);
    });
    this.getCarList(this.state.inspectionKey);
  };
  updateCAR() {
    const car = this.state.inspectionCarModel;
    if (car.id == null) return;
    //RITM0946005 - Anonimizzazione Modulo Inspection
    const item = this.state.carList.find((el) => el.id == car.id);
    if (car?.inspection.maskedValue){
      if (item.id != null){
        if (car.idOwner != null && item.idOwner != null){
          if (car.idOwner != item.idOwner){
              return showNotification.error(`${entitiesLabels.ERROR}`, 'CAR owner details cannot be updated for already masked personal information');
          }
        }
        else if (car.idOwnerSaipem != null && item.idOwnerSaipem != null)
        {
            if (car.idOwnerSaipem != item.idOwnerSaipem){
              return showNotification.error(`${entitiesLabels.ERROR}`, 'CAR owner details cannot be updated for already masked personal information');
          }
        }
      }
    }
    //End
    const url = this.getUrlDetailCar(car.id);
    api
      .put(url, car, '')
      .then((response) => {
        if (response.status == 200) {
          InspectionRepository.updateCachedCarList(car);
          showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.CAR, apioperation.PUT));
          const id = this.state.inspectionKey;
          this.getCarList(id);
          this.closemodalCar();
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.CAR, apioperation.PUT));
      })
      .finally(() => {});
  }

  confirmDeleteCAR = (id) => {
    this.setState({
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  confirmDeleteCar = () => {
    const modalHeader = {
      title: 'Delete Car',
      iconDescription: 'Close',
      buttonOnClick: () => this.handleCarDeleteCancel(),
    };

    return (
      this.state.isOpenDeleteModal && (
        <ComposedModal
          className="light-modal"
          open
          danger="false"
          onClose={() => this.handleCarDeleteCancel()}
        >
          <ModalHeader className="margin-modal" {...modalHeader}>
            <p />
          </ModalHeader>
          <ModalBody className="margin-modal">
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <h5 className="align-center">Press confirm to delete car selected </h5>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button kind="secondary" onClick={() => this.handleCarDeleteCancel()}>
              Cancel
            </Button>
            <Button kind="primary" onClick={() => this.deleteCAR()}>
              Save
            </Button>
          </ModalFooter>
        </ComposedModal>
      )
    );
  };

  deleteCAR() {
    const item = this.state.carList.find((el) => el.id == this.state.idToDelete);
    const url = `${this.baseUrl}/answer/${item.idAnswer}/car/${item.id}`;
    api
      .delete(url, '')
      .then((response) => {
        if (response.status == 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.CAR, apioperation.DELETE));
          const id = this.state.inspectionKey;
          this.getCarList(id);
          this.setState({
            isOpenDeleteModal: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.CAR, apioperation.DELETE));
      })
      .finally(() => {});
  }

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    this.setState(statusCopy);
  };

  getUrlDetailCar = (id) => {
    if (id == null) return '#';
    const item = this.state.carList.find((el) => el.id == id);
    return `${this.baseUrl}/answer/${item.idAnswer}/car/${id}`;
  };

  getStatusId = (idRow) => {
    const r = this.state.carList.find((el) => el.id == idRow);
    return r && r.idStatus;
  };

  getCanEditResource = (selectedRows) => {
    const canEditResource = this.state.inspectionModel &&
      this.state.inspectionModel.inspectionReport && {
        idCompiler: this.state.inspectionModel.inspectionReport.idCompiler,
      };

    return canEditResource;
  };

  getIsEditable(id) {
    const r = this.state.carList.find((el) => el.id == id);
    const reportStatus = r.inspectionReport.idStatus;
    if (reportStatus < 4) return true;

    return false;
  }

  render() {
    const headers = [
      { key: 'inspectionCARCode', header: 'Code' },
      { key: 'section', header: 'Section Code' },
      { key: 'requirement', header: 'Requirement Code' },
      { key: 'owner', header: 'Owner' },
      { key: 'duedate', header: 'Due Date', type: 'date' },
      { key: 'status', header: 'Status', type: 'status' },
    ];
    const skeletonRowCount = 3;

    const rows = [];

    if (this.state.carList) {
      const cars = this.state.carList.sort((a, b) => {
        const sequenceA = new Date(a.sequence);
        const sequenceB = new Date(b.sequence);
        return sequenceA - sequenceB;
      });
      cars.forEach((item) => {
        rows.push({
          id: item.id,
          idanswer: item.idAnswer,
          inspectionCARCode: item.inspectionCARCode,
          section: item.section,
          requirement: item.requirement,
          status: item.status.carSimplifiedName,
          owner:
            item.owner != null
              ? (this.state.inspectionModel.maskedValue ? (item.owner.surname != null ? item.owner.surname : `${item.owner.name} ${item.owner.surname}`) : `${item.owner.name} ${item.owner.surname}`) //RITM0946005 - Anonimizzazione Modulo Inspection
              : item.ownerSaipem != null
              ? (this.state.inspectionModel.maskedValue ? (item.ownerSaipem.surname != null ? item.ownerSaipem.surname : `${item.ownerSaipem.name} ${item.ownerSaipem.surname}`) : `${item.ownerSaipem.name} ${item.ownerSaipem.surname}`) //RITM0946005 - Anonimizzazione Modulo Inspection
              : '',
          duedate: item.dueDate,
        });
      });
    }
    const paginationProps = () => ({
      page: this.state.currentPage || 1,
      totalItems: this.state.rowCount || 0,
      pageSize: this.state.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.handleChangePaging,
    });
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb
              linkTo={`/inspection/${this.state.inspectionKey}`}
              linkText="Inspection"
              titleLeft={`Inspection Id: ${
                this.state.inspectionModel?.inspectionCode || ''
              } - CAR List`}
            />
            <div className="mainContainer">
              {this.modalCar()}
              {this.confirmDeleteCar()}
              {this.state.isLoadCar ? (
                <DataTableSkeleton
                  headers={[]}
                  rowCount={skeletonRowCount}
                  zebra={false}
                  compact={false}
                />
              ) : (
                <DataTable
                  useZebraStyles
                  rows={rows || []}
                  headers={headers}
                  render={({
                    rows,
                    headers,
                    getHeaderProps,
                    getRowProps,
                    getTableProps,
                    getSelectionProps,
                    selectedRows,
                    getBatchActionProps,
                  }) => (
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            {headers.map((header) => (
                              <TableHeader {...getHeaderProps({ header })}>
                                {header.header}
                              </TableHeader>
                            ))}
                            <TableHeader className="align-center">Actions</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows == null || rows.length == 0 ? (
                            <NoRecordsPlaceholder colSpan={headers.length + 2} />
                          ) : (
                            rows.map((row) => (
                              <TableRow {...getRowProps({ row })}>
                                {row.cells.map((cell) => (
                                  <RenderDataTableCell
                                    key={cell.id}
                                    cell={cell}
                                    header={headers.find((x) => x.key === cell.info.header)}
                                  />
                                ))}

                                <TableCell
                                  key={`action-${row.id}`}
                                  className="tableActions align-center"
                                >
                                  <div>
                                    {IsEditable(
                                      'Inspection',
                                      'CARSimplified',
                                      user,
                                      this.getStatusId(row.id),
                                      'DueDate',
                                      this.getCanEditResource(null)
                                            ) && (this.getIsEditable(row.id) || IsInRole(user, 'Administrator')) && !this.state.inspectionModel.maskedValue ? ( //RITM1095892 //RITM0946005 - Anonimizzazione Modulo Inspection
                                      <>
                                        <Button
                                          onClick={() => this.getCAR(this.getUrlDetailCar(row.id))}
                                          size="small"
                                          renderIcon={Edit16}
                                          iconDescription="Edit"
                                          kind="ghost"
                                        />
                                        <Online>
                                          <Button
                                            onClick={() => this.confirmDeleteCAR(row.id)}
                                            size="small"
                                            renderIcon={Delete16}
                                            iconDescription="Delete"
                                            kind="ghost"
                                          />
                                        </Online>
                                        <Offline>
                                          <Button
                                            size="small"
                                            renderIcon={Delete16}
                                            iconDescription="delete disabled you're offline"
                                            kind="ghost"
                                            disabled
                                          />
                                        </Offline>
                                      </>
                                    ) : null}

                                    <Link to={this.getUrlDetailCar(row.id)}>
                                      <Button
                                        size="small"
                                        renderIcon={View16}
                                        iconDescription="Detail"
                                        kind="ghost"
                                      />
                                    </Link>
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                />
                
              )}
               <div className="footer-pagination">
                <Pagination {...paginationProps()} />
              </div>
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }

  setEmployer = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state.inspectionCarModel };
      statusCopy.idOwner = employer.id;
      statusCopy.owner = employer;
      statusCopy.idOwnerSaipem = null;
      statusCopy.ownerSaipem = null;
      this.setState({ inspectionCarModel: statusCopy, mode: 0 });
    }
  };

  setSaipemOwner = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state.inspectionCarModel };
      statusCopy.idOwnerSaipem = employer.id;
      statusCopy.ownerSaipem = employer;
      statusCopy.idOwner = null;
      statusCopy.owner = null;

      this.setState({ inspectionCarModel: statusCopy, mode: 0 });
    }
  };

  showGHRS = () => {
    this.setState({ mode: 1 });
  };

  handleChangeGHRSModal() {
    this.setState({ mode: 0 });
  }

  handleChangeMode = (m) => {
    this.setState({ mode: m });
  };

  closemodalCar = () => {
    this.setState({ isOpenModalCar: false });
  };

  getCAR = (url) => {
    this.setState({
      isLoading: true,
    });
    api
      .get(url, '')
      .then((response) => {
        const { data } = response;
        if (data) {
          this.setState({
            inspectionCarModel: data,
            isOpenModalCar: true,
          });
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`,'CAR not found');
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.CAR, apioperation.GET));
        this.props.history.push(this.baseUrl);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  updateStateDPCAR = (inputName, inputValue, objName) => {
    this.setState({
      inspectionCarModel: {
        ...this.state.inspectionCarModel,
        dueDate: inputValue,
      },
    });
  };

  onDetailsOfInefficiencyChange(event) {
    const { value } = event.currentTarget;
    this.setState({
      inspectionCarModel: {
        ...this.state.inspectionCarModel,
        detailsOfInefficiency: value,
      },
    });
  }

  modalCar() {
    const modalHeader = {
      title: `Edit Inspection Car: ${this.state?.inspectionCarModel?.inspectionCARCode}`,
      iconDescription: 'Close',
      buttonOnClick: () => this.closemodalCar(),
    };
    if (this.state.mode === 1) {
      return (
        <FindGHRSEmployer
          isOpenModal={this.state.isOpenModalCar}
          onCancel={() => this.handleChangeMode(0)}
          onOk={this.setEmployer}
        />
      );
    }
    if (this.state.mode === 2) {
      return (
        <FindSaipemCompilers
          isOpenModal={this.state.isOpenModalCar}
          url={`/inspection/${this.state.inspectionCarModel.idInspection}/car/compilers/`}
          onCancel={() => this.handleChangeMode(0)}
          onOk={this.setSaipemOwner}
        />
      );
    }
    return (
      <ComposedModal
        className="light-modal"
        open={this.state.isOpenModalCar}
        danger="false"
        onClose={() => false}
      >
        <ModalHeader className="margin-modal" {...modalHeader}>
          <p />
        </ModalHeader>
        <ModalBody className="margin-modal">
          <div className="bx--grid--full-width">
            <div className="bx--row">
              <Form className="bx--grid--full-width form--multi ">
                {this.state.isLoadingElement ? <Loading /> : ''}
                <div className="bx--row ">
                  <FormGroup legendText="" className="bx--col-md-4">
                    <FormLabel className="some-class">Due Date*</FormLabel>
                    {this.state.isLoadingDate ? (
                      <DatePickerSkeleton />
                    ) : (
                      <DateTimePicker
                        value={this.state.inspectionCarModel?.dueDate}
                        type="date"
                        placeholder={DateFormat}
                        name="dueDate"
                        alt="carModel"
                        // invalid={validations.duedate != null}
                        onChange={this.updateStateDPCAR}
                      />
                    )}
                  </FormGroup>

                  <FormGroup legendText="Find Owner on GHRS or Saipem*">
                    <div className="bx--row two-button-center">
                      <div className="bx--col-lg-6 bx--col-md-6">
                        <Button
                          kind="primary"
                          className="bx--col"
                          onClick={() => this.handleChangeMode(1)}
                          disabled={this.state.inspectionModel.maskedValue} //RITM0946005 - Anonimizzazione Modulo Inspection
                        >
                          GHRS research
                        </Button>
                      </div>
                      <div className="bx--col-lg-6 bx--col-md-6">
                        <Button
                          kind="primary"
                          className="bx--col button--line--content"
                          onClick={() => this.handleChangeMode(2)}
                          disabled={this.state.inspectionModel.maskedValue} //RITM0946005 - Anonimizzazione Modulo Inspection
                        >
                          Saipem research
                        </Button>
                      </div>
                    </div>
                  </FormGroup>

                  <FormGroup legendText="" className="bx--col-md-4">
                    <FormLabel className="some-class">Owner Full Name*</FormLabel>
                    <TextInput
                      id={
                        this.state.inspectionCarModel?.owner
                          ? `${this.state.inspectionCarModel.owner.name} ${this.state.inspectionCarModel.owner.surname}`
                          : this.state.inspectionCarModel?.ownerSaipem
                          ? `${this.state.inspectionCarModel.ownerSaipem.name} ${this.state.inspectionCarModel.ownerSaipem.surname}`
                          : ''
                      }
                      name="idEmployer"
                      placeholder="Search Car Owner"
                      required
                      value={
                        this.state.inspectionCarModel?.owner
                          ? (this.state.inspectionModel.maskedValue ? ((`${this.state.inspectionCarModel.owner.name} ${this.state.inspectionCarModel.owner.surname}`) != null ? this.state.inspectionCarModel.owner.maskedValue : `${this.state.inspectionCarModel.owner.name} ${this.state.inspectionCarModel.owner.surname}`) :`${this.state.inspectionCarModel.owner.name} ${this.state.inspectionCarModel.owner.surname}`) //RITM0946005 - Anonimizzazione Modulo Inspection
                          : this.state.inspectionCarModel?.ownerSaipem
                          ? (this.state.inspectionModel.maskedValue ? ((`${this.state.inspectionCarModel.ownerSaipem.name} ${this.state.inspectionCarModel.ownerSaipem.surname}`) != null ? this.state.inspectionCarModel.ownerSaipem.fullNameMasked : `${this.state.inspectionCarModel.ownerSaipem.name} ${this.state.inspectionCarModel.ownerSaipem.surname}`) : `${this.state.inspectionCarModel.ownerSaipem.name} ${this.state.inspectionCarModel.ownerSaipem.surname}`) //RITM0946005 - Anonimizzazione Modulo Inspection
                          : ''
                      }
                      onChange={this.handleChangeModelCar}
                      type="text"
                      labelText=""
                      className="bx--text-input  bx--text-input--light camp--description "
                      disabled
                    />
                  </FormGroup>
                  <FormGroup legendText="" className="bx--col-md-4">
                    <FormLabel className="some-class">Owner Email*</FormLabel>
                    <TextInput
                      id={
                        this.state.inspectionCarModel?.owner
                          ? `${this.state.inspectionCarModel.owner.name} ${this.state.inspectionCarModel.owner.surname}`
                          : this.state.inspectionCarModel?.ownerSaipem
                          ? `${this.state.inspectionCarModel.ownerSaipem.name} ${this.state.inspectionCarModel.ownerSaipem.surname}`
                          : ''
                      }
                      name="idEmployer"
                      placeholder="Search Car Owner"
                      required
                      value={
                        this.state.inspectionCarModel?.owner
                          ? (this.state.inspectionModel.maskedValue ? (this.state.inspectionCarModel.owner.email != null ? this.state.inspectionCarModel.owner.emailMasked : this.state.inspectionCarModel.owner.email) : this.state.inspectionCarModel.owner.email) //RITM0946005 - Anonimizzazione Modulo Inspection
                          : this.state.inspectionCarModel?.ownerSaipem
                          ? (this.state.inspectionModel.maskedValue ? (this.state.inspectionCarModel.ownerSaipem.email != null ? this.state.inspectionCarModel.ownerSaipem.emailMasked : this.state.inspectionCarModel.ownerSaipem.email) : this.state.inspectionCarModel.ownerSaipem.email) //RITM0946005 - Anonimizzazione Modulo Inspection
                          : ''
                      }
                      onChange={this.handleChangeModelCar}
                      type="text"
                      labelText=""
                      className="bx--text-input  bx--text-input--light camp--description "
                      disabled
                    />
                  </FormGroup>
                  <FormGroup legendText="Details Of Inefficiency*">
                    <TextArea
                      maxLength={5000}
                      labelText=""
                      id="inputDetailOfInefficiency"
                      name="inputdetailsofinefficiency"
                      cols={250}
                      disabled={false}
                      invalid={false}
                      invalidText="required"
                      light
                      placeholder="Input Details of Inefficiency"
                      rows={5}
                      value={this.state.inspectionCarModel?.detailsOfInefficiency}
                      onChange={this.onDetailsOfInefficiencyChange}
                    />
                  </FormGroup>
                </div>
              </Form>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={() => this.closemodalCar()}>
            Cancel
          </Button>
          <Button kind="primary" onClick={() => this.updateCAR()}>
            Save
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }
}
